import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {UntypedFormControl, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * «Видалити» for an act whose tax invoice 1C has already registered: the act is not deleted but reversed by a debt
 * adjustment, and the reason is written into it, so it is mandatory here.
 */
@Component({
    selector: 'app-reverse-act-dialog',
    templateUrl: './reverse-act-dialog.component.html',
    styleUrls: ['./reverse-act-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReverseActDialogComponent {
    reason: UntypedFormControl = new UntypedFormControl('', [Validators.required]);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            actName: string
        },
        public dialogRef: MatDialogRef<ReverseActDialogComponent>,
    ) {
    }

    submitForm() {
        if (this.reason.invalid || !this.reason.value?.trim()) {
            this.reason.markAsTouched();
            return;
        }

        this.closeDialog(true, this.reason.value.trim());
    }

    closeDialog(result: boolean, data?: any) {
        this.dialogRef.close({result, data});
    }
}
